export default __webpack_public_path__ + "static/media/04_DAIF_Infra_04_03_end.4822a95b.jpg";